import {
	EditOrCloneProductDrawerMode,
	Product,
	ProductType
} from "@/Contracts/Products";

export enum EProductDrawerState {
	ADD = "add",
	BUNDLECHILDEDIT = "bundlechildedit",
	ETILIZEADD = "etilizeadd",
	EDITORCLONE = "editorclone",
	ADDAMAZON = "addamazon"
}
export interface IAddProductDrawerProps {
	readonly shouldRedirectToProduct?: boolean;
	readonly onAdd?: (product: Product) => void;
	readonly defaultProductType?: ProductType;
	readonly visible: boolean;
	readonly productVsPricing?: Record<string, string | null>;
	readonly onClose?: () => void;
	readonly drawerState: EProductDrawerState;
	readonly currentActiveProduct?: Product | null;
	readonly mode?: EditOrCloneProductDrawerMode | null;
}
